import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"w100 centered mt20\"><span class=\"fs20 fw600\">ヘッダーテキストを編集</span></div><div class=\"clear mb5\"></div><p class=\"fs16 mt20 fw600\"> 【タイトル】 <span class=\"fs12\"> なんのための日程調整付きフォーム？</span></p><div class=\"clear\"></div>", 4)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 【内容】 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, " なんのための日程調整付きフォームなのかわかりやすく説明しましょう！")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_TextareaTag, {
        placeholder: "予約受付ページ",
        class: "fl fs18 roundForm mw100 mt5",
        style: `height:80px;`,
        value: _ctx.rcm.appeal_content ? _ctx.rcm.appeal_content.title : ``,
        onInputValue: _ctx.inputAppealContentTitle
      }, null, 8, ["value", "onInputValue"]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      (_ctx.rcm.appeal_content?.content_type == `text`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addLinkButton && _ctx.addLinkButton(...args)))
            }, "+リンクボタンを追加"),
            _createElementVNode("div", {
              class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeContentType(`delta`)))
            }, " エディタモードに切り替え ")
          ]))
        : (_ctx.rcm.appeal_content?.content_type == `delta`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeContentType(`text`)))
              }, " テキストモードに切り替え ")
            ]))
          : _createCommentVNode("", true),
      _hoisted_11,
      (_ctx.rcm.appeal_content?.content_type == `text`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_TextareaTag, {
              placeholder: "お問い合わせいただきありがとうございます。",
              class: "fl fs14 roundForm mw100 mt20",
              style: `height:300px;`,
              value: _ctx.rcm.appeal_content ? _ctx.rcm.appeal_content.content : ``,
              onInputValue: _ctx.inputAppealContent
            }, null, 8, ["value", "onInputValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_QuillEditor, {
        class: _normalizeClass(`fl fs14 roundForm mw100 mt20 ${_ctx.rcm.appeal_content?.content_type == `delta` ? `` : `nodisp`}`),
        style: {"height":"300px"},
        ref: "QuillEditor",
        options: _ctx.toolbarOptions,
        contentType: `delta`,
        "onUpdate:content": _ctx.inputAppealDeltaContent
      }, null, 8, ["class", "options", "onUpdate:content"]),
      _hoisted_13
    ])
  ]))
}